/* eslint-disable */
// GENERATED by scripts/icons/generate-phosphor-registry.mjs -- do not edit by hand.
//
// vite.config.mts resolves `vue-tabler-icons` to this file. Every tabler export
// passes through unchanged from the real package; the names in tablerMap.ts are
// then shadowed by Phosphor Regular stand-ins with the same name and props.
export * from 'vue-tabler-icons-original';
import { tablerIcon, TablerPhosphorPlugin } from './tablerPhosphor';

export const ActivityIcon = tablerIcon('ActivityIcon');
export const AdjustmentsHorizontalIcon = tablerIcon('AdjustmentsHorizontalIcon');
export const AdjustmentsIcon = tablerIcon('AdjustmentsIcon');
export const AlertCircleIcon = tablerIcon('AlertCircleIcon');
export const AlertTriangleIcon = tablerIcon('AlertTriangleIcon');
export const AlignCenterIcon = tablerIcon('AlignCenterIcon');
export const AlignLeftIcon = tablerIcon('AlignLeftIcon');
export const AlignRightIcon = tablerIcon('AlignRightIcon');
export const ApertureIcon = tablerIcon('ApertureIcon');
export const AppsIcon = tablerIcon('AppsIcon');
export const ArchiveIcon = tablerIcon('ArchiveIcon');
export const ArrowBackIcon = tablerIcon('ArrowBackIcon');
export const ArrowBackUpIcon = tablerIcon('ArrowBackUpIcon');
export const ArrowBadgeLeftIcon = tablerIcon('ArrowBadgeLeftIcon');
export const ArrowBigUpIcon = tablerIcon('ArrowBigUpIcon');
export const ArrowDownIcon = tablerIcon('ArrowDownIcon');
export const ArrowDownRightIcon = tablerIcon('ArrowDownRightIcon');
export const ArrowLeftIcon = tablerIcon('ArrowLeftIcon');
export const ArrowRightIcon = tablerIcon('ArrowRightIcon');
export const ArrowUpIcon = tablerIcon('ArrowUpIcon');
export const ArrowUpLeftIcon = tablerIcon('ArrowUpLeftIcon');
export const ArrowUpRightIcon = tablerIcon('ArrowUpRightIcon');
export const ArrowsShuffleIcon = tablerIcon('ArrowsShuffleIcon');
export const ArticleIcon = tablerIcon('ArticleIcon');
export const BasketIcon = tablerIcon('BasketIcon');
export const BeachIcon = tablerIcon('BeachIcon');
export const BellIcon = tablerIcon('BellIcon');
export const BellOffIcon = tablerIcon('BellOffIcon');
export const BellRingingIcon = tablerIcon('BellRingingIcon');
export const BluetoothIcon = tablerIcon('BluetoothIcon');
export const BoldIcon = tablerIcon('BoldIcon');
export const BoltIcon = tablerIcon('BoltIcon');
export const BookIcon = tablerIcon('BookIcon');
export const BoxIcon = tablerIcon('BoxIcon');
export const BoxSeamIcon = tablerIcon('BoxSeamIcon');
export const BrandFacebookIcon = tablerIcon('BrandFacebookIcon');
export const BrandGithubIcon = tablerIcon('BrandGithubIcon');
export const BrandInstagramIcon = tablerIcon('BrandInstagramIcon');
export const BrandTwitterIcon = tablerIcon('BrandTwitterIcon');
export const BriefcaseIcon = tablerIcon('BriefcaseIcon');
export const BuildingCarouselIcon = tablerIcon('BuildingCarouselIcon');
export const BuildingIcon = tablerIcon('BuildingIcon');
export const BulbIcon = tablerIcon('BulbIcon');
export const CalculatorIcon = tablerIcon('CalculatorIcon');
export const CalculatorOffIcon = tablerIcon('CalculatorOffIcon');
export const CalendarCheckIcon = tablerIcon('CalendarCheckIcon');
export const CalendarEventIcon = tablerIcon('CalendarEventIcon');
export const CalendarIcon = tablerIcon('CalendarIcon');
export const CalendarOffIcon = tablerIcon('CalendarOffIcon');
export const CalendarTimeIcon = tablerIcon('CalendarTimeIcon');
export const CameraPlusIcon = tablerIcon('CameraPlusIcon');
export const CardboardsIcon = tablerIcon('CardboardsIcon');
export const CashIcon = tablerIcon('CashIcon');
export const ChartBarIcon = tablerIcon('ChartBarIcon');
export const ChartBubbleIcon = tablerIcon('ChartBubbleIcon');
export const ChartLineIcon = tablerIcon('ChartLineIcon');
export const ChartPieIcon = tablerIcon('ChartPieIcon');
export const CheckIcon = tablerIcon('CheckIcon');
export const CheckboxIcon = tablerIcon('CheckboxIcon');
export const ChecksIcon = tablerIcon('ChecksIcon');
export const ChevronDownIcon = tablerIcon('ChevronDownIcon');
export const ChevronLeftIcon = tablerIcon('ChevronLeftIcon');
export const ChevronRightIcon = tablerIcon('ChevronRightIcon');
export const ChevronUpIcon = tablerIcon('ChevronUpIcon');
export const CircleCheckIcon = tablerIcon('CircleCheckIcon');
export const CircleDotIcon = tablerIcon('CircleDotIcon');
export const CircleIcon = tablerIcon('CircleIcon');
export const CircleMinusIcon = tablerIcon('CircleMinusIcon');
export const CircleXIcon = tablerIcon('CircleXIcon');
export const ClipboardCheckIcon = tablerIcon('ClipboardCheckIcon');
export const ClipboardIcon = tablerIcon('ClipboardIcon');
export const ClipboardListIcon = tablerIcon('ClipboardListIcon');
export const ClipboardOffIcon = tablerIcon('ClipboardOffIcon');
export const ClipboardTextIcon = tablerIcon('ClipboardTextIcon');
export const ClockIcon = tablerIcon('ClockIcon');
export const CloudIcon = tablerIcon('CloudIcon');
export const CloudOffIcon = tablerIcon('CloudOffIcon');
export const CloudRainIcon = tablerIcon('CloudRainIcon');
export const CloudStormIcon = tablerIcon('CloudStormIcon');
export const CloudUploadIcon = tablerIcon('CloudUploadIcon');
export const CopyIcon = tablerIcon('CopyIcon');
export const CreditCardIcon = tablerIcon('CreditCardIcon');
export const CrossIcon = tablerIcon('CrossIcon');
export const CrownIcon = tablerIcon('CrownIcon');
export const CurrencyDollarIcon = tablerIcon('CurrencyDollarIcon');
export const DashboardIcon = tablerIcon('DashboardIcon');
export const DatabaseIcon = tablerIcon('DatabaseIcon');
export const DeviceFloppyIcon = tablerIcon('DeviceFloppyIcon');
export const DiamondIcon = tablerIcon('DiamondIcon');
export const DotsIcon = tablerIcon('DotsIcon');
export const DotsVerticalIcon = tablerIcon('DotsVerticalIcon');
export const DownloadIcon = tablerIcon('DownloadIcon');
export const DragDropIcon = tablerIcon('DragDropIcon');
export const DropletIcon = tablerIcon('DropletIcon');
export const EditIcon = tablerIcon('EditIcon');
export const EraserIcon = tablerIcon('EraserIcon');
export const ExternalLinkIcon = tablerIcon('ExternalLinkIcon');
export const EyeIcon = tablerIcon('EyeIcon');
export const EyeOffIcon = tablerIcon('EyeOffIcon');
export const FileCheckIcon = tablerIcon('FileCheckIcon');
export const FileDescriptionIcon = tablerIcon('FileDescriptionIcon');
export const FileDownloadIcon = tablerIcon('FileDownloadIcon');
export const FileIcon = tablerIcon('FileIcon');
export const FileInvoiceIcon = tablerIcon('FileInvoiceIcon');
export const FilePlusIcon = tablerIcon('FilePlusIcon');
export const FileReportIcon = tablerIcon('FileReportIcon');
export const FileSearchIcon = tablerIcon('FileSearchIcon');
export const FileSpreadsheetIcon = tablerIcon('FileSpreadsheetIcon');
export const FileTextIcon = tablerIcon('FileTextIcon');
export const FileUploadIcon = tablerIcon('FileUploadIcon');
export const FileZipIcon = tablerIcon('FileZipIcon');
export const FilterIcon = tablerIcon('FilterIcon');
export const FlameIcon = tablerIcon('FlameIcon');
export const FolderDownIcon = tablerIcon('FolderDownIcon');
export const FolderFilledIcon = tablerIcon('FolderFilledIcon');
export const FolderIcon = tablerIcon('FolderIcon');
export const FolderPinIcon = tablerIcon('FolderPinIcon');
export const FolderPlusIcon = tablerIcon('FolderPlusIcon');
export const FolderSearchIcon = tablerIcon('FolderSearchIcon');
export const FoldersIcon = tablerIcon('FoldersIcon');
export const FoldersOffIcon = tablerIcon('FoldersOffIcon');
export const GiftIcon = tablerIcon('GiftIcon');
export const GridDotsIcon = tablerIcon('GridDotsIcon');
export const GripVerticalIcon = tablerIcon('GripVerticalIcon');
export const HammerIcon = tablerIcon('HammerIcon');
export const HandMoveIcon = tablerIcon('HandMoveIcon');
export const HashIcon = tablerIcon('HashIcon');
export const HeartIcon = tablerIcon('HeartIcon');
export const HelmetIcon = tablerIcon('HelmetIcon');
export const HelpIcon = tablerIcon('HelpIcon');
export const HistoryIcon = tablerIcon('HistoryIcon');
export const Home2Icon = tablerIcon('Home2Icon');
export const HomeCogIcon = tablerIcon('HomeCogIcon');
export const HomeIcon = tablerIcon('HomeIcon');
export const HomeUpIcon = tablerIcon('HomeUpIcon');
export const InboxIcon = tablerIcon('InboxIcon');
export const InfinityIcon = tablerIcon('InfinityIcon');
export const InfoCircleFilledIcon = tablerIcon('InfoCircleFilledIcon');
export const InfoCircleIcon = tablerIcon('InfoCircleIcon');
export const LanguageIcon = tablerIcon('LanguageIcon');
export const LanguageKatakanaIcon = tablerIcon('LanguageKatakanaIcon');
export const LayersIntersectIcon = tablerIcon('LayersIntersectIcon');
export const LayoutColumnsIcon = tablerIcon('LayoutColumnsIcon');
export const LayoutDashboardIcon = tablerIcon('LayoutDashboardIcon');
export const LayoutDistributeHorizontalIcon = tablerIcon('LayoutDistributeHorizontalIcon');
export const LayoutDistributeVerticalIcon = tablerIcon('LayoutDistributeVerticalIcon');
export const LayoutGridIcon = tablerIcon('LayoutGridIcon');
export const LayoutIcon = tablerIcon('LayoutIcon');
export const LayoutNavbarIcon = tablerIcon('LayoutNavbarIcon');
export const LayoutSidebarIcon = tablerIcon('LayoutSidebarIcon');
export const LayoutSidebarLeftCollapseIcon = tablerIcon('LayoutSidebarLeftCollapseIcon');
export const LinkIcon = tablerIcon('LinkIcon');
export const LinkOffIcon = tablerIcon('LinkOffIcon');
export const ListCheckIcon = tablerIcon('ListCheckIcon');
export const ListDetailsIcon = tablerIcon('ListDetailsIcon');
export const ListIcon = tablerIcon('ListIcon');
export const ListNumbersIcon = tablerIcon('ListNumbersIcon');
export const LockIcon = tablerIcon('LockIcon');
export const LockOpenIcon = tablerIcon('LockOpenIcon');
export const LoginIcon = tablerIcon('LoginIcon');
export const LogoutIcon = tablerIcon('LogoutIcon');
export const MailIcon = tablerIcon('MailIcon');
export const MapIcon = tablerIcon('MapIcon');
export const MapPinIcon = tablerIcon('MapPinIcon');
export const MaximizeIcon = tablerIcon('MaximizeIcon');
export const Menu2Icon = tablerIcon('Menu2Icon');
export const Message2Icon = tablerIcon('Message2Icon');
export const MessageCircle2Icon = tablerIcon('MessageCircle2Icon');
export const MessageCircleIcon = tablerIcon('MessageCircleIcon');
export const MessageIcon = tablerIcon('MessageIcon');
export const MessagesIcon = tablerIcon('MessagesIcon');
export const MinimizeIcon = tablerIcon('MinimizeIcon');
export const MinusIcon = tablerIcon('MinusIcon');
export const MinusVerticalIcon = tablerIcon('MinusVerticalIcon');
export const MoodSmileIcon = tablerIcon('MoodSmileIcon');
export const MovieIcon = tablerIcon('MovieIcon');
export const NoteIcon = tablerIcon('NoteIcon');
export const NotebookIcon = tablerIcon('NotebookIcon');
export const NotesIcon = tablerIcon('NotesIcon');
export const PackageIcon = tablerIcon('PackageIcon');
export const PaletteIcon = tablerIcon('PaletteIcon');
export const PaperclipIcon = tablerIcon('PaperclipIcon');
export const PencilIcon = tablerIcon('PencilIcon');
export const PencilOffIcon = tablerIcon('PencilOffIcon');
export const PercentageIcon = tablerIcon('PercentageIcon');
export const PhoneCallIcon = tablerIcon('PhoneCallIcon');
export const PhoneIcon = tablerIcon('PhoneIcon');
export const PhotoIcon = tablerIcon('PhotoIcon');
export const PictureInPictureIcon = tablerIcon('PictureInPictureIcon');
export const PictureInPictureTopIcon = tablerIcon('PictureInPictureTopIcon');
export const PinIcon = tablerIcon('PinIcon');
export const PinnedIcon = tablerIcon('PinnedIcon');
export const PlayerPlayIcon = tablerIcon('PlayerPlayIcon');
export const PlayerSkipBackIcon = tablerIcon('PlayerSkipBackIcon');
export const PlayerSkipForwardIcon = tablerIcon('PlayerSkipForwardIcon');
export const PlusIcon = tablerIcon('PlusIcon');
export const PowerIcon = tablerIcon('PowerIcon');
export const PrinterIcon = tablerIcon('PrinterIcon');
export const ProgressIcon = tablerIcon('ProgressIcon');
export const ReceiptIcon = tablerIcon('ReceiptIcon');
export const RectangleFilledIcon = tablerIcon('RectangleFilledIcon');
export const RefreshIcon = tablerIcon('RefreshIcon');
export const ReportMoneyIcon = tablerIcon('ReportMoneyIcon');
export const RocketIcon = tablerIcon('RocketIcon');
export const RotateIcon = tablerIcon('RotateIcon');
export const RouteIcon = tablerIcon('RouteIcon');
export const RulerIcon = tablerIcon('RulerIcon');
export const RulerMeasureIcon = tablerIcon('RulerMeasureIcon');
export const ScissorsIcon = tablerIcon('ScissorsIcon');
export const ScreenShareIcon = tablerIcon('ScreenShareIcon');
export const SearchIcon = tablerIcon('SearchIcon');
export const SelectIcon = tablerIcon('SelectIcon');
export const SelectorIcon = tablerIcon('SelectorIcon');
export const SendIcon = tablerIcon('SendIcon');
export const SettingsCodeIcon = tablerIcon('SettingsCodeIcon');
export const SettingsIcon = tablerIcon('SettingsIcon');
export const Share2Icon = tablerIcon('Share2Icon');
export const ShieldCheckIcon = tablerIcon('ShieldCheckIcon');
export const ShieldIcon = tablerIcon('ShieldIcon');
export const ShieldLockIcon = tablerIcon('ShieldLockIcon');
export const ShoppingCartIcon = tablerIcon('ShoppingCartIcon');
export const SparklesIcon = tablerIcon('SparklesIcon');
export const SquareIcon = tablerIcon('SquareIcon');
export const StackIcon = tablerIcon('StackIcon');
export const SunIcon = tablerIcon('SunIcon');
export const TagIcon = tablerIcon('TagIcon');
export const TargetIcon = tablerIcon('TargetIcon');
export const TemplateIcon = tablerIcon('TemplateIcon');
export const TextDirectionLtrIcon = tablerIcon('TextDirectionLtrIcon');
export const TextDirectionRtlIcon = tablerIcon('TextDirectionRtlIcon');
export const TextSizeIcon = tablerIcon('TextSizeIcon');
export const ThumbUpIcon = tablerIcon('ThumbUpIcon');
export const ToolIcon = tablerIcon('ToolIcon');
export const TrashFilledIcon = tablerIcon('TrashFilledIcon');
export const TrashIcon = tablerIcon('TrashIcon');
export const TrashOffIcon = tablerIcon('TrashOffIcon');
export const TrendingDownIcon = tablerIcon('TrendingDownIcon');
export const TrendingUpIcon = tablerIcon('TrendingUpIcon');
export const TruckDeliveryIcon = tablerIcon('TruckDeliveryIcon');
export const TruckIcon = tablerIcon('TruckIcon');
export const TypographyIcon = tablerIcon('TypographyIcon');
export const UmbrellaIcon = tablerIcon('UmbrellaIcon');
export const UploadIcon = tablerIcon('UploadIcon');
export const UserCheckIcon = tablerIcon('UserCheckIcon');
export const UserCircleIcon = tablerIcon('UserCircleIcon');
export const UserIcon = tablerIcon('UserIcon');
export const UserPlusIcon = tablerIcon('UserPlusIcon');
export const UserStarIcon = tablerIcon('UserStarIcon');
export const UsersIcon = tablerIcon('UsersIcon');
export const VersionsFilledIcon = tablerIcon('VersionsFilledIcon');
export const VolumeIcon = tablerIcon('VolumeIcon');
export const WandIcon = tablerIcon('WandIcon');
export const WifiIcon = tablerIcon('WifiIcon');
export const WindIcon = tablerIcon('WindIcon');
export const WorldWwwIcon = tablerIcon('WorldWwwIcon');
export const XIcon = tablerIcon('XIcon');
export const ZoomInIcon = tablerIcon('ZoomInIcon');
export const ZoomOutIcon = tablerIcon('ZoomOutIcon');

export default TablerPhosphorPlugin;
